<template>
  <el-container class="container" id="recibo">
    <el-col
      :xs="24"
      :sm="22"
      :md="20"
      :lg="16"
      :xl="14"
    >
      <el-row
        class="hide-on-print"
        type="flex"
        justify="center"
      >
        <el-button @click="print()" v-if="!$isWebView()">
          Imprimir
        </el-button>
        <router-link
          to="/busqueda-del-predio" style="margin-left: 10px"
          v-if="tipo !== 'avaluos'"
        >
          <el-button>
            Consultar otra cuenta
          </el-button>
        </router-link>
      </el-row>
      <el-row
        type="flex"
        style="margin-top: 10px;"
        class="colors"
      >
        <el-col style="background: #4DBB9A;" />
        <el-col style="background: #FB862F;" />
        <el-col style="background: #FA3773;" />
        <el-col style="background: #74BD76;" />
        <el-col style="background: #00A8DB;" />
      </el-row>
      <el-row type="flex" class="top-banner">
        <img src="../assets/images/logo-gobierno-zapopan.gif" alt="Logo gobierno de Zapopan">
        <div class="info">
          <p>Av. Hidalgo 151 C.P. 45100</p>
          <p>Cabezera Municipal</p>
          <p>RFC <b>MZJ890101MS8</b></p>
        </div>
        <img
          src="../assets/images/logo-tesoreria.png"
          alt="Logo Tesorería"
        >
        <div class="qr" id="qr" />
        <div class="info2">
          <p>RECIBO ELECTRÓNICO</p>
          <p>
            {{ tipo === 'pago-predial' ? 'IMPUESTO PREDIAL' : '' }}
            {{ tipo === 'certificado-no-adeudos' ? 'CERTIFICADO NO ADEUDOS' : '' }}
            {{ tipo === 'avaluos' ? 'AVALUO' : '' }}
          </p>
          <p style="text-align: left">
            REFERENCIA
          </p>
          <p>PAG_EXTERN {{ receipt.recibo.fecha }}</p>
        </div>
      </el-row>
      <el-row class="taxpayer-predio-info">
        <div class="badge-title">
          <p>
            DATOS DEL CONTRIBUYENTE
          </p>
        </div>
        <el-row class="taxpayer-info" type="flex">
          <el-col :span="12">
            <div>
              <p>NOMBRE:</p>
              <p>{{ receipt.nombre_contribuyente }}</p>
            </div>
            <div>
              <p>
                DOMICILIO DE NOTIFICACION:
              </p>
              <p>{{ receipt.domicilio }}</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="badge-title">
              <p>
                DATOS DEL PREDIO
              </p>
            </div>
            <el-row class="predio-info">
              <el-col :span="14">
                <div>
                  <p>CLAVE PREDIAL:</p>
                  <p>{{ propertyKeyFormater(receipt.clave_catastral) }}</p>
                </div>
                <div>
                  <p>SUP. TERRENO:</p>
                  <p>{{ $numberFormater(receipt.superficie_terreno_total) }}</p>
                </div>
                <div>
                  <p>SUP. COMUN:</p>
                  <p>{{ $numberFormater(receipt.superficie_terreno_comun) }}</p>
                </div>
                <div>
                  <p>UBICACIÓN:</p>
                  <p>{{ receipt.ubicacion }}</p>
                </div>
                <div>
                  <p>TIPO:</p>
                  <p>{{ receipt.tipo_de_predio }}</p>
                </div>
                <div>
                  <p>ESTATUS DEL PREDIO:</p>
                  <p>{{ receipt.estado_actual }}</p>
                </div>
              </el-col>
              <el-col :span="10">
                <div>
                  <p>CUENTA:</p>
                  <p>{{ receipt.cuenta_predial }}</p>
                </div>
                <div>
                  <p>SUP. CONSTR:</p>
                  <p>{{ $numberFormater(receipt.superficie_construccion) }}</p>
                </div>
                <div>
                  <p>SUP. PRIVADA:</p>
                  <p>{{ $numberFormater(receipt.superficie_terreno_privada) }}</p>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-row>
      <!-- Concepto Pago de predial -->
      <el-row class="concept">
        <div class="badge-title">
          <p>
            CONCEPTO
          </p>
        </div>
        <div v-if="tipo === 'pago-predial'">
          <el-col :span="7">
            <p class="el-col-7">
              PERIODO
            </p>
            <el-row type="flex" style="width: 100%">
              <el-col :span="3">
                <p>AÑO</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ item.periodo.anio }}
                </p>
              </el-col>
              <el-col :span="2">
                <p class="bim">
                  BIM <br> INI
                </p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ item.periodo.bimestre_inicial }}
                </p>
              </el-col>
              <el-col :span="2">
                <p class="bim">
                  BIM <br> FIN
                </p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ item.periodo.bimestre_final }}
                </p>
              </el-col>
              <el-col :span="6">
                <p>VAL. FISCAL</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.valor_catastral) }}
                </p>
              </el-col>
              <el-col :span="3">
                <p>TASA</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ item.tasa || '' }}
                </p>
              </el-col>
              <el-col :span="5">
                <p>IMPUESTO</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.total_impuestos) }}
                </p>
              </el-col>
              <el-col :span="3">
                <p>ACT</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.total_actualizacion) }}
                </p>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="4">
            <p>RECARGOS</p>
            <el-row type="flex" style="width: 100%">
              <el-col :span="12">
                <p>CORRIENTE</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.recargos.total_corriente) }}
                </p>
              </el-col>
              <el-col :span="12">
                <p>EJ. ANTERIOR</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.recargos.total_ej_anterior) }}
                </p>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="4">
            <p>GASTOS</p>
            <el-row type="flex" style="width: 100%">
              <el-col :span="8">
                <p>NOT.</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.gastos.total_notificacion) }}
                </p>
              </el-col>
              <el-col :span="8">
                <p>EJE.</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.gastos.total_ejecucion) }}
                </p>
              </el-col>
              <el-col :span="8">
                <p>MULTAS</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.gastos.total_multas) }}
                </p>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="9">
            <p class="discount-label">
              DESCUENTOS
            </p>
            <el-row type="flex" style="width: 100%;">
              <el-col :span="3">
                <p>NOT.</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.descuentos.total_notificacion) }}
                </p>
              </el-col>
              <el-col :span="3">
                <p>EJEC.</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.descuentos.total_ejecucion) }}
                </p>
              </el-col>
              <el-col :span="3">
                <p>MULTAS</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.descuentos.total_multas) }}
                </p>
              </el-col>
              <el-col :span="4">
                <p>DESC. REC.</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.descuentos.total_recargos) }}
                </p>
              </el-col>
              <el-col :span="3">
                <p>PAG. ANT.</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.descuentos.total_prontopago) }}
                </p>
              </el-col>
              <el-col :span="3">
                <p>REDU.</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.descuentos.total_especiales) }}
                </p>
              </el-col>
              <el-col :span="4">
                <p>SUBTOTAL</p>
                <p
                  v-for="(item, index) in receipt.recibo.pagos"
                  :key="index"
                >
                  {{ $currencyFormater(item.subtotal) }}
                </p>
              </el-col>
            </el-row>
          </el-col>
        </div>
        <!-- Concepto Certificado de no adeudos -->
        <div v-if="tipo === 'certificado-no-adeudos'">
          <p>
            LA TESORERÍA MUNICIPAL DE ZAPOPAN, JALISCO, HACE CONSTAR QUE EL INMUEBLE CUYOS DATOS SE
            ESPECIFICAN EN LA PARTE SUPERIOR DE ESTE DOCUMENTO, SE ENCUETRAS AL CORRIENTE DEL PAGO
            DEL IMPUESTO PREDIAL HASTA EL BIMESTRE {{ receipt.recibo.bimestre }}
            DEL {{ receipt.recibo.anio }}
          </p>
          <br>
          <p>
            EL IMPUESTO PREDIAL HA SIDO CALCULADO CONFORME EL VALOR FISCAL Y LA TASA DETERMINADOS
            EN EL COMPROBANTE 1 Y NO LIBERA AL PREDIO DE CARGOS POSTERIORES QUE RESULTEN POR
            CAMBIO DE DATOS FISCALES.
          </p>
        </div>
        <!-- Concepto Avaluos -->
        <div v-if="tipo === 'avaluos'" id="avaluos">
          <el-row
            type="flex" align="center"
            justify="center"
          >
            <el-col
              :xs="24" :sm="24"
              :md="4"
            >
              <p>Recibo</p>
              <p>{{ receipt.recibo.pk }}</p>
            </el-col>
            <el-col
              :xs="24" :sm="24"
              :md="16"
            >
              <p>Concepto</p>
              <p>{{ receipt.recibo.concepto }}</p>
            </el-col>
            <el-col
              :xs="24" :sm="24"
              :md="4"
            >
              <p>Subtotal</p>
              <p style="text-align: right !important; padding-right: 5px">
                {{ $currencyFormater(receipt.recibo.subtotal) }}
              </p>
            </el-col>
          </el-row>
        </div>
      </el-row>
      <el-row class="sello-summary" type="flex">
        <el-col :span="16" class="sello">
          <!--  img -->
          <img src="../assets/images/sello.png">
          <p>{{ receipt.recibo.fecha }}</p>
        </el-col>
        <el-col :span="8" class="summary">
          <el-row type="flex">
            <p>SUBTOTAL:</p>
            <p>{{ $currencyFormater(receipt.recibo.subtotal) }}</p>
          </el-row>
          <el-row type="flex">
            <p>APORTACIONES:</p>
            <p>{{ $currencyFormater(receipt.recibo.salud) }}</p>
          </el-row>
          <el-row type="flex">
            <p>SEGURO:</p>
            <p>{{ $currencyFormater(receipt.recibo.seguro) }}</p>
          </el-row>
          <el-row type="flex">
            <p>REDONDEO:</p>
            <p>{{ $currencyFormater(receipt.recibo.importe_redondeado) }}</p>
          </el-row>
        </el-col>
      </el-row>
      <el-row type="flex" class="autorization">
        <el-col :span="8">
          <p>AUTORIZACIÓN</p>
          <el-row type="flex">
            <p>RECIBO</p>
            <p>{{ receipt.recibo.pk }}</p>
          </el-row>
          <el-row type="flex">
            <p>FACTURA</p>
            <p>{{ receipt.recibo.referencia_factura }}</p>
          </el-row>
        </el-col>
        <el-col :span="8" class="total">
          <el-row type="flex">
            <p style="letter-spacing: 4px">
              TOTAL
            </p>
            <p>{{ $currencyFormater(receipt.recibo.total) }}</p>
          </el-row>
        </el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="24" class="text">
          <p>
            "El presente recibo se expide de conformidad con el artículo 25, párrafo segundo de la
            Ley de Ingresos del Municipio de Zapopan, Jalisco, para el ejercicio fiscal del año
            2020."
          </p>
          <p>
            Este recibo es electrónico y una copia del original.
          </p>
          <p>
            Comprobante fiscal en el sitio:
            <a href="http://facturas.zapopan.gob.mx/facturacion/">
              http://facturas.zapopan.gob.mx/facturacion/
            </a>
          </p>
          <p>
            Información proactiva Impuesto Predial:
            <a href="http://www.zapopan.gob.mx/info-predial">
              http://www.zapopan.gob.mx/info-predial
            </a>
          </p>
          <p>
            Correo:
            <a href="mailto:informacionpredial@zapopan.gob.mx">
              informacionpredial@zapopan.gob.mx
            </a>
          </p>
          <p>
            "El Impuesto Predial correspondiente al ejercicio fiscal 2020, se calcula de acuerdo
            a lo que resulte de aplicar bimestralmente a la base fiscal, las cuotas y tasas
            establecidas por el artículo 45, fracción I, de la Ley de Ingresos del Municipio de
            Zapopan, Jalisco, para el Ejercicio Fiscal del año 2020".
          </p>
        </el-col>
      </el-row>
      <el-row
        type="flex" justify="center"
        class="last-info"
      >
        <el-col :span="12" style="margin-right: 1px;background-color: #CCCCCC; padding: 3px;">
          <p>ESTE PAGO NO LIBERA</p>
          <p>AL CONTRIBUYENTE DE ADEUDOS ANTERIORES</p>
        </el-col>
        <el-col :span="12" style="margin-left: 1px;background-color: #CCCCCC; padding: 3px;">
          <p>CONSERVE ESTE RECIBO PARA CUALQUIER ACLARACIÓN,</p>
          <p>O PARA REALIZAR SU PRÓXIMO PAGO</p>
        </el-col>
      </el-row>
    </el-col>
  </el-container>
</template>

<script>
import qrcode from 'qrcode-generator';

export default {
  props: {
    receipt: {
      type: Object,
      required: true,
    },
    tipo: {
      type: String,
      required: true,
      validator: (val) => [
        'certificado-no-adeudos',
        'pago-predial',
        'avaluos',
      ].includes(val),
    },
  },
  methods: {
    /**
     * Muestra mensaje al usuario.
     */
    openMessage() {
      this.$alert(
        'Para una mejor experiencia se recomienda usar el dispositivo en modo horizontal',
        '', {
          confirmButtonText: 'OK',
        },
      );
    },
    /**
     * Abre la ventana de impresión en PDF del navegador.
     */
    async print() {
      await this.generateQR(640);
      window.print();
      await this.generateQR();
    },
    /**
     * Genera QR.
     */
    async generateQR(w = null) {
      const qr = qrcode(0, 'L');
      const name = this.receipt.nombre_contribuyente;
      const predio = this.receipt.cuenta_predial;
      const recibo = this.receipt.recibo.pk;
      const dateTime = this.receipt.recibo.fecha;
      const amount = this.receipt.recibo.total;
      const data = `${name}|${predio}|${recibo}|${dateTime}|${amount}`;
      qr.addData(data);
      qr.make();
      let image = await qr.createImgTag();
      image = `${image.slice(0, 4)} class="qr-img"${image.slice(4)}`;
      // eslint-disable-next-line no-restricted-globals
      let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
      width = w || width;
      if (width < 640) {
        image = image.replace(/(width\s*=\s*["'](.*?)["'])/g, 'width="40"');
        image = image.replace(/(height\s*=\s*["'](.*?)["'])/g, 'height="40"');
      } else {
        image = image.replace(/(width\s*=\s*["'](.*?)["'])/g, 'width="70"');
        image = image.replace(/(height\s*=\s*["'](.*?)["'])/g, 'height="70"');
      }

      document.getElementById('qr').innerHTML = image;
    },
    /**
     * Formateador para clave catastral
     * @returns {String} clave catastral
     */
    propertyKeyFormater(str = '') {
      const strFilled = str.padEnd(18, ' ');
      const chunks = [
        strFilled.substr(0, 7),
        strFilled.substr(7, 3),
        strFilled.substr(10, 4),
        strFilled.substring(14, undefined),
      ];
      return chunks.join('-');
    },
  },
  /**
    * Evento de entrada a la pantalla.
    */
  mounted() {
    this.generateQR();
    window.onresize = () => this.generateQR();
    // eslint-disable-next-line no-restricted-globals
    const width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    if (width < 420) {
      this.openMessage();
    }
  },
};
</script>

<style lang="scss" scoped>
* p {
  word-break: break-word;
}
.container {
  * {
    font-family: 'Trebuchet MS' !important;
  }
  font-size: 12px;
  justify-content: center;
  padding: 0px 0 30px 0;
  overflow: hidden;
  .colors {
    height: 10px;
  }
  .el-button {
    background-color: #956FA8;
    color: #FFFFFF;
  }
  .top-banner {
    height: 100px;
    align-items: center;
    justify-content: space-between;
    img {
      height: 85px;
    }
    .info, .info2 {
      display: flex;
      height: 100%;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .info {
      p {
        color: #323232;
      }
    }
    .info2 {
      p {
        width: 200px;
        text-align: center;
        font-weight: bold;
        font-size: 8pt;
        line-height: 25px;
        &:nth-child(1) {
          color: #353535;
        }
        &:nth-child(2) {
          color: #000000;
          background-color: #D9E1E0;
        }
        &:nth-child(3) {
          color: #FFFFFF;
          background-color: #666666;
        }
        &:nth-child(4) {
          font-weight: normal;
        }
      }
    }
  }
  .badge-title {
    color: #FFFFFF;
    background-color: #999999;
    font-weight: bold;
    font-size: 16px;
    border-radius: 15px;
    text-align: center;
    padding: 3px;
    margin: 5px 0;
  }
  .taxpayer-info {
    font-size: 10pt;
    .el-col:nth-child(1) {
      div {
        padding: 5px;
        display: flex;
        flex-direction: row;
        p:nth-child(1) {
          width: 100px;
        }
      }
    }
    .predio-info {
      font-size: 8pt;
      .el-col {
        div {
          padding: 5px;
          display: flex;
          flex-direction: row;
          p:nth-child(1) {
            width: 100px;
          }
          p:nth-child(2) {
            padding-left: 10px;
          }
        }
      }
    }
  }
  .concept {
    .discount-label {
      width: calc(79.16667% + 5px);
    }
    #avaluos .el-col p:nth-child(1) {
      font-size: 14px !important;
      color: #FFFFFF;
    }
    .el-col {
      p:nth-child(1) {
        background-color: #99ADAB;
        font-size: 8pt;
        text-align: center;
        margin-right: 1px;
      }
      .el-row {
        min-height: 50px;
        .el-col {
          min-height: 50px;
          margin: 1px 1px 1px 0px;
          .bim {
            line-height: 12.5px !important;
          }
          p:nth-child(1), p {
            line-height: 25px;
            width: 100%;
            text-align: center;
            height: 25px;

          }
          p:nth-child(1) {
            background-color: #333333;
            color: #FFFFFF;
            font-size: 8px;
          }
          p {
            background-color: #FFFFFF;
            color: #000000;
            font-size: 8px;
          }
        }
      }
    }
  }
  .sello {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      height: 155px;
      width: 155px;
    }
    p {
      color: #111983;
      font-size: 10pt;
      transform: translateY(-85px) rotate(-2deg)
    }
  }
  .summary {
    padding: 20px;
    p {
      padding: 5px 0;
      font-size: 10pt;
      &:nth-child(1) {
        width: 50%;
      }
      &:nth-child(2) {
        width: 100px;
        text-align: end;
      }
    }
  }
  .autorization {
    justify-content: space-between;
    .el-col:nth-child(1) {
      background-color: #CCCCCC;
      padding: 10px;
      p {
        width: 50%;
        padding: 2px;
        font-size: 10pt;
        &:nth-child(2) {
          text-align: end;
          padding-right: 15px;
        }
      }
    }
    .total {
      .el-row {
        align-items: center;
        justify-content: space-evenly;
        height: 100%;
        p  {
          font-size: 15pt;
          &:nth-child(2) {
            padding-left: 15px;
          }
        }
      }
    }
  }
  .text {
    padding: 20px 0;
    font-size: 8pt;
  }
  .last-info {
    font-size: 10pt;
    text-align: center;
    .el-col {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
}

@media only screen and (max-width: 805px) {
  .container {
    .top-banner {
      height: 80px;
      img {
        height: 60px;
      }
      .info {
        p {
          font-size: 12px;
        }
      }
      .info2 {
        p {
          width: 150px;
          font-size: 12px;
          line-height: 13px;
        }
      }
    }
  }
}

@media only screen and (max-width: 640px) {
  .container {
    padding-top: 0px !important;
    .top-banner {
      height: 50px;
      img {
        height: 45px;
      }
      .info {
        p {
          font-size: 9px;
        }
      }
      .info2 {
        p {
          width: 100px;
          font-size: 7px;
          line-height: 9px;
        }
      }
    }
    .taxpayer-predio-info {
      .el-col {
        width: 100% !important;
      }
      .taxpayer-info {
        flex-direction: column !important;
      }
    }
    .badge-title {
      font-size: 12px;
    }
    .concept {
      .el-col {
        p:nth-child(1) {
          font-size: 8px;
        }
        .el-row {
          min-height: 35px;
          .el-col {
            min-height: 35px;
            .bim {
              line-height: 8px !important;
            }
            p:nth-child(1), p {
              line-height: 16px;
              height: 16px;

            }
            p:nth-child(1) {
              font-size: 5px;
            }
            p {
              font-size: 5px;
            }
          }
        }
      }
    }
    .sello-summary {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .sello {
      img {
        height: 85px;
        width: 85px;
      }
      p {
        font-size: 8px;
        transform: translateY(-48px) rotate(-2deg)
      }
    }
    .summary {
      width: 100%;
      padding: 10px;
      p {
        padding: 5px 0;
        font-size: 10px;
        &:nth-child(1) {
          width: 50%;
        }
        &:nth-child(2) {
          // width: 100px;
          width: 100%;
          text-align: end;
        }
      }
    }
    .autorization {
      flex-direction: column-reverse;
      .el-col:nth-child(1) {
        width: 100%;
        p {
          font-size: 10px;
        }
      }
      .total {
        width: 100%;
        .el-row {
          // flex-direction: column;
          justify-content: flex-end !important;
          padding-right: 10px;
          p  {
            font-size: 12px;
          }
        }
      }
    }
    .text {
      font-size: 8px;
    }
    .last-info {
      font-size: 8px;
    }
  }
}

@media only screen and (max-width: 411px) {
  .container {
    .colors {
      height: 5px;
    }
    .top-banner {
      height: 50px;
      img {
        height: 40px;
      }
      .info {
        p {
          font-size: 7px;
        }
      }
      .info2 {
        p {
          width: 80px;
          font-size: 6px;
          line-height: 11px;
        }
      }
    }
    .taxpayer-info {
      font-size: 10px;
    }
  }
}

@media only screen and (max-width: 321px) {
  .container {
    .colors {
      height: 5px;
    }
    .top-banner {
      height: 45px;
      img {
        height: 30px;
      }
      .info {
        p {
          font-size: 5px;
        }
      }
      .info2 {
        p {
          width: 75px;
          font-size: 6px;
        }
      }
    }
    .concept {
      .el-col {
        p:nth-child(1) {
          font-size: 5px;
        }
        .el-row {
          min-height: 35px;
          .el-col {
            min-height: 35px;
            .bim {
              line-height: 6px !important;
            }
            p:nth-child(1), p {
              line-height: 12px;
              height: 12px;
            }
            p:nth-child(1) {
              font-size: 3px;
            }
            p {
              font-size: 4px;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  #avaluos {
    .el-row {
      display: unset !important;
    }
  }
}
</style>

<style lang="scss">
@media print {
  .hide-on-print, .header {
    display: none;
  }
  .container {
    padding: 0 20px;
  }
}
</style>
